import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ITag } from 'src/app/models/tag/tag.model';
import { IUserInfoCognito } from './cognito.service';

@Injectable({
  providedIn: 'root'
})
export class TagService {
    private endpoint: string = environment.backend.tag.url;
    private readonly REQUEST_ORIGIN = 'WEB';

    constructor(
        private _sessionService: SessionService,
        private http: HttpClient
    ) { }

    private getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
        const headers = new HttpHeaders()
            .set("IDOrganizacion", idOrganizacion)
            .set("IDUsuario", idUsuario)
            .set("requestOrigin", requestOrigin)

        return headers
    }

    buildHttpParams(paramsObj?: Record<string, string | null | undefined>): HttpParams {
        let params = new HttpParams();

        if (!paramsObj) return params;

        for (const [key, value] of Object.entries(paramsObj)) {
            if (value != null && value !== '') {
                params = params.set(key, value);
            }
        }

        return params;
    }

    public createTagReport(rut: string): Observable<ITag> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut };

        return this.http.post<ITag>(`${this.endpoint}highwayDebt`, payload, { headers });
    }

    public listReports(rut: string) {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ rut });

        return this.http.get(`${this.endpoint}highwayDebts`, { headers, params });
    }

    public searchTX(idTransaccion: string): Observable<ITag> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ idTransaccion });

        return this.http.get<ITag>(`${this.endpoint}highwayDebt`, { headers, params });
    }
}
